<template>
  <div
    class="flex flex-col gap-2 text-darkGray-1 w-full text-sm"
    v-if="isEditing"
  >
    <div class="flex gap-4 items-center">
      <label class="col-span-2 mb-1 flex items-center gap-2">
        Lägsta ålder vid periodens start
      </label>
      <input
        type="number"
        class="appearance-none border-gray-2 block bg-blue-4 text-darkGray-1 placeholder-darkGray-4 rounded py-1 px-2 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
        :class="{ 'border-2 border-red-2': v$.ageLow.$error }"
        placeholder="Ange ålder"
        v-model="addValidator().data.minAge"
        @input="$emit('input', item.data)"
      />
      <span
        v-if="v$.ageLow.$error"
        class="p-1 text-white text-xs col-span-full place-self-end"
        >{{ v$.ageLow.$errors[0].$message }}
      </span>
    </div>
    <div class="flex gap-4 items-center">
      <label class="col-span-2 mb-1 flex items-center gap-2">
        Högsta ålder vid periodens slut
      </label>
      <input
        type="number"
        class="appearance-none border-gray-2 block bg-blue-4 text-darkGray-1 placeholder-darkGray-4 rounded py-1 px-2 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
        :class="{ 'border-2 border-red-2': v$.ageHigh.$error }"
        placeholder="Ange ålder"
        v-model="addValidator().data.maxAge"
        @input="$emit('input', addValidator().data)"
      />
      <span
        v-if="v$.ageHigh.$error"
        class="p-1 text-white col-span-full place-self-end text-xs"
        >{{ v$.ageHigh.$errors[0].$message }}
      </span>
    </div>
    <div class="flex gap-2" v-if="false">
      
      <button
        @click="saveValidation"
        class="text-blue-2 hover:text-blue-1 text-left text-sm py-1 px-4 bg-white rounded-lg w-fit"
      >
        Spara villkor
      </button>
      
      <button
        @click="() => removeValidation()"
        class="text-red-2 hover:text-red-1 text-left text-sm py-1 px-4 bg-white flex items-center gap-2 rounded-lg"
      >
        Ta bort villkor
      </button>
    </div>
  </div>
  <div class="flex flex-col gap-2 bg-blue-4 text-white w-full text-sm" v-else>
    <p>
      <strong class="leading-relaxed tracking-wide"
        >Följande villkor är aktivt: </strong
      >Minst {{ item.data.minAge }} år vid periodens start och max
      {{ item.data.maxAge }} år vid periodens slut.
    </p>
    <div class="flex gap-2">
      <button
        @click="isEditing = !isEditing"
        class="text-blue-2 hover:text-blue-1 text-left text-sm py-1 px-4 bg-white rounded-lg w-fit"
      >
        Redigera villkor
      </button>
      <button
        @click="() => removeValidation(0)"
        class="text-red-2 hover:text-red-1 text-left text-sm py-1 px-4 bg-white flex items-center gap-2 rounded-lg"
      >
        <span>Ta bort villkor</span>
        <i class="fas fa-close"></i>
      </button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, defineProps, defineEmits, reactive, onMounted } from "vue";
import useValidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";

import { computed } from "@vue/reactivity";
import { AgePeriod, RangePeriod, ValidatorPeriod } from "@/models/forms/AgePeriod";
import { DOMNodeTransforms, processSlotOutlet } from "@vue/compiler-dom";
import * as dtos from "@/models/dtos";
const props = defineProps({  
   item:{
    type: dtos.DynamicProperty,
    required: true
    },
  index:{
    type: String,
    required: true
  },
  periodKey:{
    type:String,
    required:true
  }
});
/*

*/
onMounted ( () => {
addValidator();
});

const addValidator = () : dtos.AllowedAgeInPeriodPropertyValidator => {
 var validator = props.item.validators.find( (x) => x.name == "allowedAgeInPeriod");
if (validator)
{

}
else
{
  var period = new dtos.AllowedAgeInPeriod();  
  validator = new dtos.AllowedAgeInPeriodPropertyValidator(period);
  props.item.validators.push(validator);

}
return validator;
};

const isEditing = ref(true);

const messages = {
  required: "Fältet är obligatoriskt",
  startDateIsBeforeEndDate: "Datumet kan inte vara före periodens startdatum",
  endDateIsAfterStartDate: "Datumet kan inte vara efter periodens slutdatum",
  ageIsHigherThanMaxAge: "Åldern kan inte vara lägre än maxåldern",
  ageIsLowerThanMinAge: "Åldern kan inte vara högre än minåldern",
  ageIsPositive: "Åldern kan inte vara negativ",
};

const rules = computed(() => {
  return {
    ageLow: {
      required: helpers.withMessage(messages.required, required),
      ageIsPositive: helpers.withMessage(
        messages.ageIsPositive,
        (value: number) => {
          return value >= 0;
        }
      ),
      ageIsLowerThanMinAge: helpers.withMessage(
        messages.ageIsLowerThanMinAge,
        (value: number) => {
          return value <= props.age.maxAge;
        }
      ),
    },
    ageHigh: {
      required: helpers.withMessage(messages.required, required),
      ageIsPositive: helpers.withMessage(
        messages.ageIsPositive,
        (value: number) => {
          return value >= 0;
        }
      ),
      ageIsHigherThanMaxAge: helpers.withMessage(
        messages.ageIsHigherThanMaxAge,
        (value: number) => {
          return value >= props.age.minAge;
        }
      ),
    },
  };
});
const _age = reactive({
  ageLow: 10,
  ageHigh: 11,
});

const v$ = useValidate(rules, _age);

const validate = () => {
  v$.value.$validate();
  if (!v$.value.$error) {
    return true;
  } else {
    return false;
  }
};

const emit = defineEmits(["removeValidation", "saveValidation", "input"]);

const removeValidation = () => {
  emit("removeValidation", props.index);
};

const saveValidation = () => {
  if (!validate()) {
    return;
  }
  isEditing.value = false;
  //emit("saveValidation", props.index, props.age.iageLow, period.ageHigh);
};
</script>
